const MATTERPORT_REGEX = /https:\/\/my.matterport.com\/show\/*.[^\s]*/g;

const getMatterportLink = (description: string): string | undefined =>
  description.match(MATTERPORT_REGEX)?.[0];

export { getMatterportLink };
